import { api } from "@/lib/api";

const KEY = "yk_pending_events";

function pending() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function track(name, meta) {
  if (!localStorage.getItem("yk_token")) return;
  if (navigator.onLine === false) { localStorage.setItem(KEY, JSON.stringify([...pending(), { name, meta }].slice(-200))); return; }
  api.post("/events", { name, meta }).catch(() => {});
}

export async function flushEvents() {
  const q = pending();
  if (!q.length || !localStorage.getItem("yk_token")) return;
  localStorage.removeItem(KEY);
  for (const e of q) await api.post("/events", e).catch(() => {});
}

if (typeof window !== "undefined") window.addEventListener("online", flushEvents);
